(($) => {

    'use strict'

    // Hero home slider
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $('.hero-home__slider, .hero-home-v2__slider').flickity(
    {
        autoPlay: 7000,
        draggable: false,
        fullscreen: true,
        pageDots: false,
        pauseAutoPlayOnHover: false,
        prevNextButtons: false,
    });

    $('.statistics__top-5__button').each(function() {
        var button = $(this)
        button.click(function() {

            $('.statistics__top-5__button').each(function() {
                $(this).removeClass('active')
            })

            button.addClass('active')

            $('#top-5 .statistics__tab').each(function() {
                $(this).hide()
            })
            $('#top-5 .statistics__tab#' + button.data('toggle')).each(function() {
                $(this).show()
            })

            $('#top-5 h2').each(function() {
                $(this).hide()
            })
            $('#top-5 h2#' + button.data('toggle') + '-title').each(function() {
                $(this).show()
            })
        })
    })

    $('.statistics__goals__button').each(function() {
        var button = $(this)
        button.click(function() {
            $('.statistics__goals > .row').each(function() {
                $(this).hide()
            })
            $('.statistics__goals > .row#' + button.data('toggle')).each(function() {
                $(this).show()
            })
        })
    })

    function daylights_savings(dt) {
        var dst = null;
        for (var i = 0; i < 12; ++i) {
            var d = new Date(dt.getFullYear(), i, 1)
            var offset = dt.getTimezoneOffset()

            if (dst === null) {
                dst = offset;
            } else if (offset < dst) {
                dst = offset;
                break;
            } else if (offset > dst) {
                break;
            }
        }
        return (dt.getTimezoneOffset() == dst) | 0;
    }

    // Countdown
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var next_game_countdown = $('.next-game-countdown, .hero-home__countdown, .hero-home-v2__countdown')
    if (next_game_countdown.length) {
        var interval = setInterval(() => {

            var now = new Date()
            if (daylights_savings(now)) {
                now = now.getTime() + (60 * 60 * 1000)
            } else {
                now = now.getTime()
            }
            var distance = next_game_countdown.data('date') * 1000 - now

            var days = ('0' + Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2)
            if (days > 0) {
                next_game_countdown.find('.days > .time').text(days)
            }

            var hours = ('0' + Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2)
            if (hours > 0) {
                next_game_countdown.find('.hours > .time').text(hours)
            }

            var minutes = ('0' + Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2)
            if (minutes > 0) {
                next_game_countdown.find('.minutes > .time').text(minutes)
            }

            var seconds = ('0' + Math.floor((distance % (1000 * 60)) / 1000)).slice(-2)
            if (seconds > 0) {
                next_game_countdown.find('.seconds > .time').text(seconds)
            }

            if (distance < 0) {
                clearInterval(interval)
            }

        }, 1000)
    }

    // Live time
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var live_ticker_editor = $('.live-ticker-editor')
    if (live_ticker_editor.length) {

        var scheduled_kickoff = live_ticker_editor.data('scheduled-kickoff')
        var field_live_event_min = live_ticker_editor.find('#acf-field_live_event_min')

        var now = new Date()
        if (daylights_savings(now)) {
            now = now.getTime() + (60 * 60 * 1000)
        } else {
            now = now.getTime()
        }
        var distance = (scheduled_kickoff * 1000) - now
        field_live_event_min.val(Math.floor(distance / 1000 / 60 * -1))

    }

    // Live ticker item backend
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $('.live-ticker-editor .btn-edit').each(function() {
        $(this).click(function(event) {
            event.preventDefault()
            $(this).parent().parent().parent().find('tr#item-' + $(this).data('live')).toggleClass('open')
        })
    })

    // Live ticker front
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var match_live_ticker = $('.single-match #live')
    if (match_live_ticker.length) {

        var get_live_items = function() {
            $.ajax({
                method: 'GET',
                url: siteGlobals.siteUrl + '/wp-json/vnv/v1/get_live_items/',
                data: {
                    'match': match_live_ticker.data('match'),
                },
                dataType: "html",
                success: function(response) {
                    if (response != '') {
                        var html = '<div style=""><h2 class="title-lg" style="text-align: center;"><small class="very-small">Suivez-nous</small>en live</h2></div>'
                        match_live_ticker.html(html + response)
                        match_live_ticker.addClass('loaded')
                    }
                },
            })
        }

        get_live_items()
        if (match_live_ticker.data('refresh') == '1') {
            setInterval(function() {
                get_live_items()
            }, 30000)
        }

    }

    // Match info
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var match_goals_total = $('.single-match #match_goals_total')
    var match_goals_halftime = $('.single-match #match_goals_halftime')

    var match_teams_home_goals_total = $('.single-match #match_teams_home_goals_total')
    var match_teams_guest_goals_total = $('.single-match #match_teams_guest_goals_total')
    var match_statistics_shots_home = $('.single-match #match_statistics_shots_home')
    var match_statistics_shots_guest = $('.single-match #match_statistics_shots_guest')
    var match_statistics_shots_on_goal_home = $('.single-match #match_statistics_shots_on_goal_home')
    var match_statistics_shots_goals_home = $('.single-match #match_statistics_shots_goals_home')
    var match_statistics_shots_held_shots_home = $('.single-match #match_statistics_shots_held_shots_home')
    var match_statistics_shots_on_goal_guest = $('.single-match #match_statistics_shots_on_goal_guest')
    var match_statistics_shots_goals_guest = $('.single-match #match_statistics_shots_goals_guest')
    var match_statistics_shots_held_shots_guest = $('.single-match #match_statistics_shots_held_shots_guest')
    var match_statistics_failed_shots_home = $('.single-match #match_statistics_failed_shots_home')
    var match_statistics_failed_shots_goal_frame_home = $('.single-match #match_statistics_failed_shots_goal_frame_home')
    var match_statistics_failed_shots_missed_home = $('.single-match #match_statistics_failed_shots_missed_home')
    var match_statistics_failed_shots_blocked_home = $('.single-match #match_statistics_failed_shots_blocked_home')
    var match_statistics_failed_shots_guest = $('.single-match #match_statistics_failed_shots_guest')
    var match_statistics_failed_shots_goal_frame_guest = $('.single-match #match_statistics_failed_shots_goal_frame_guest')
    var match_statistics_failed_shots_missed_guest = $('.single-match #match_statistics_failed_shots_missed_guest')
    var match_statistics_failed_shots_blocked_guest = $('.single-match #match_statistics_failed_shots_blocked_guest')
    var match_statistics_possession_home = $('.single-match #match_statistics_possession_home')
    var match_statistics_possession_guest = $('.single-match #match_statistics_possession_guest')
    var match_statistics_corners_home = $('.single-match #match_statistics_corners_home')
    var match_statistics_corners_guest = $('.single-match #match_statistics_corners_guest')
    var match_statistics_offsides_home = $('.single-match #match_statistics_offsides_home')
    var match_statistics_offsides_guest = $('.single-match #match_statistics_offsides_guest')
    var match_statistics_freekicks_home = $('.single-match #match_statistics_freekicks_home')
    var match_statistics_freekicks_guest = $('.single-match #match_statistics_freekicks_guest')
    var match_statistics_penaltykicks_home = $('.single-match #match_statistics_penaltykicks_home')
    var match_statistics_penaltykicks_guest = $('.single-match #match_statistics_penaltykicks_guest')
    var match_statistics_yellow_cards_home = $('.single-match #match_statistics_yellow_cards_home')
    var match_statistics_yellow_cards_guest = $('.single-match #match_statistics_yellow_cards_guest')
    var match_statistics_red_cards_home = $('.single-match #match_statistics_red_cards_home')
    var match_statistics_red_cards_guest = $('.single-match #match_statistics_red_cards_guest')
    var match_statistics_substitutions_home = $('.single-match #match_statistics_substitutions_home')
    var match_statistics_substitutions_guest = $('.single-match #match_statistics_substitutions_guest')

    if (match_goals_total.length) {

        var get_match_fields = function() {

            $.ajax({
                method: 'GET',
                url: siteGlobals.siteUrl + '/wp-json/rest/match/current',
                data: {
                    'match': match_goals_total.data('match'),
                },
                dataType: "json",
                success: function(response) {

                    // console.info(response)

                    match_goals_total.html(response.match_teams_home_goals_total + ' - ' + response.match_teams_guest_goals_total)
                    match_goals_halftime.html(response.match_teams_home_goals_halftime + ' - ' + response.match_teams_guest_goals_halftime)

                    match_teams_home_goals_total.html('<span>' + response.match_teams_home_goals_total + '<span>')
                    match_teams_guest_goals_total.html('<span>' + response.match_teams_guest_goals_total + '</span>')
                    match_statistics_shots_home.html('<span>' + response.match_statistics_shots_home + '</span>')
                    match_statistics_shots_guest.html('<span>' + response.match_statistics_shots_guest + '</span>')
                    match_statistics_shots_on_goal_home.html('<span>' + response.match_statistics_shots_on_goal_home + '</span>')
                    match_statistics_shots_goals_home.html('<span>' + response.match_statistics_shots_goals_home + '</span>')
                    match_statistics_shots_held_shots_home.html('<span>' + response.match_statistics_shots_held_shots_home + '</span>')
                    match_statistics_shots_on_goal_guest.html('<span>' + response.match_statistics_shots_on_goal_guest + '</span>')
                    match_statistics_shots_goals_guest.html('<span>' + response.match_statistics_shots_goals_guest + '</span>')
                    match_statistics_shots_held_shots_guest.html('<span>' + response.match_statistics_shots_held_shots_guest + '</span>')
                    match_statistics_failed_shots_home.html('<span>' + response.match_statistics_failed_shots_home + '</span>')
                    match_statistics_failed_shots_goal_frame_home.html('<span>' + response.match_statistics_failed_shots_goal_frame_home + '</span>')
                    match_statistics_failed_shots_missed_home.html('<span>' + response.match_statistics_failed_shots_missed_home + '</span>')
                    match_statistics_failed_shots_blocked_home.html('<span>' + response.match_statistics_failed_shots_blocked_home + '</span>')
                    match_statistics_failed_shots_guest.html('<span>' + response.match_statistics_failed_shots_guest + '</span>')
                    match_statistics_failed_shots_goal_frame_guest.html('<span>' + response.match_statistics_failed_shots_goal_frame_guest + '</span>')
                    match_statistics_failed_shots_missed_guest.html('<span>' + response.match_statistics_failed_shots_missed_guest + '</span>')
                    match_statistics_failed_shots_blocked_guest.html('<span>' + response.match_statistics_failed_shots_blocked_guest + '</span>')
                    match_statistics_possession_home.html('<span>' + response.match_statistics_possession_home + '</span>')
                    match_statistics_possession_guest.html('<span>' + response.match_statistics_possession_guest + '</span>')
                    match_statistics_corners_home.html('<span>' + response.match_statistics_corners_home + '</span>')
                    match_statistics_corners_guest.html('<span>' + response.match_statistics_corners_guest + '</span>')
                    match_statistics_offsides_home.html('<span>' + response.match_statistics_offsides_home + '</span>')
                    match_statistics_offsides_guest.html('<span>' + response.match_statistics_offsides_guest + '</span>')
                    match_statistics_freekicks_home.html('<span>' + response.match_statistics_freekicks_home + '</span>')
                    match_statistics_freekicks_guest.html('<span>' + response.match_statistics_freekicks_guest + '</span>')
                    match_statistics_penaltykicks_home.html('<span>' + response.match_statistics_penaltykicks_home + '</span>')
                    match_statistics_penaltykicks_guest.html('<span>' + response.match_statistics_penaltykicks_guest + '</span>')
                    match_statistics_yellow_cards_home.html('<span>' + response.match_statistics_yellow_cards_home + '</span>')
                    match_statistics_yellow_cards_guest.html('<span>' + response.match_statistics_yellow_cards_guest + '</span>')
                    match_statistics_red_cards_home.html('<span>' + response.match_statistics_red_cards_home + '</span>')
                    match_statistics_red_cards_guest.html('<span>' + response.match_statistics_red_cards_guest + '</span>')
                    match_statistics_substitutions_home.html('<span>' + response.match_statistics_substitutions_home + '</span>')
                    match_statistics_substitutions_guest.html('<span>' + response.match_statistics_substitutions_guest + '</span>')

                },
            })
        }

        get_match_fields()
        setInterval(function() {
            get_match_fields()
        }, 60000)

    }


    // Navigation widget
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    var navigation_widget = $('.secondary-navigation .navigation-widget')
    $('#menu-main-navigation > .menu-item-has-children').each(function() {
        $(this).hover(function() {

            navigation_widget
                .width($('.secondary-navigation').innerWidth() - 50)

            if (!$(this).find('.navigation-widget').length) {
                navigation_widget
                    .clone()
                    .appendTo($(this).children('.sub-menu'))
            }

        }, function() {
            navigation_widget.remove()
        })
    })

    // Burger for mobile menu
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $('#mobile-navigation-toggle').click(() => {

        if ($('.mobile-navigations').hasClass('is-active')) {

            $('#mobile-navigation-toggle').removeClass('is-active')
            $('.mobile-navigations').removeClass('is-active')
            $('#top').css('position', 'relative')

            $('.mobile-navigations').css('z-index', 0)

        } else {

            $('#mobile-navigation-toggle').addClass('is-active')
            $('.mobile-navigations').css('z-index', 100)
            $('.mobile-navigations').addClass('is-active')
            $('#top').css('position', 'fixed')

        }

    })

    $('.main-mobile-navigation > li.menu-item-has-children > a').each(function() {
        $(this).click(function(event) {
            $(this).parent('.menu-item-has-children').toggleClass('is-active')
            event.preventDefault()
        })
    })

    // Repeat links in mobile navigation
    $('.mobile-navigations .menu-item-has-children').each(function() {

        var item = $(this);

        item
            .find(' > a')
            .clone()
            .prependTo($(this).find('>.sub-menu'))
            .wrap('<li class="menu-item menu-item-type-custom menu-item-object-custom" style="padding-bottom: 1rem;"></li>')

        item.find(' > a').on('click', function(event) {
            event.preventDefault()
            item.toggleClass('opened')
        })

    })

    $('#header-secondary-outer .menu-item').each(function() {

        var item = $(this);
        item
            .clone()
            .appendTo($('.main-mobile-navigation'))

    });

    // Width of secondary navigation
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

    if ($(window).width() >= 999) {
        $('.secondary-navigation-width').width($('.secondary-navigation').outerWidth())
        if($('.hero-home__sidebar').length){        
            $('.hero-home .hero.custom .background').css({
                'right': "calc(" + $('.secondary-navigation').outerWidth() + "px)"
            })
        }
    }

    if ($(window).width() <= 999) {
        $('.hero-home .hero.custom .background').css({
            'right': "0"
        })
    }

    if ($(window).width() >= 1245) {
        $('.secondary-navigation-width').css('margin-top', $('#menu-main-navigation').outerHeight() + $('#header-secondary-outer').outerHeight())
    } else {
        $('.secondary-navigation-width').css('margin-top', $('#menu-main-navigation').outerHeight() + $('#menu-main-navigation').outerHeight() + $('#header-secondary-outer').outerHeight())
    }

    $(window).resize(function() {
        if ($(window).width() >= 999) {
            if($('.hero-home__sidebar').length){      
                $('.hero-home .hero.custom .background').css({
                    'right': "calc(" + $('.secondary-navigation').outerWidth() + "px)"
                })
            }
            $('.hero-home h1').css({
                'margin-right': "calc(4vw + " + $('.secondary-navigation').outerWidth() + "px)"
            })
        }
        if ($(window).width() <= 999) {
            $('.hero-home .hero.custom .background').css({
                'right': "0"
            })
        }
        if ($(window).width() >= 999) {
            $('.secondary-navigation-width').width($('.secondary-navigation').outerWidth())
        }
        if ($(window).width() >= 1245) {
            $('.secondary-navigation-width').css('margin-top', $('#menu-main-navigation').outerHeight() + $('#header-secondary-outer').outerHeight())
        } else {
            $('.secondary-navigation-width').css('margin-top', $('#menu-main-navigation').outerHeight() + $('.secondary-navigation').outerHeight() + $('#header-secondary-outer').outerHeight())
        }
    })

    // Right page selector
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

    $('.right-page-selector').click(function(event) {
        event.preventDefault()
        if (!$(this).hasClass('active')) {
            $('.right-page-selector').each(function(index, el) {
                $(this).removeClass('active')
                $('#' + $(this).data('target')).toggle()
            })
            $(this).addClass('active')
        }
    })

    // Line up selectors
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■

    $('.line-up-selector').click(function(event) {
        event.preventDefault()
        if (!$(this).hasClass('active')) {
            $('.line-up-selector').each(function(index, el) {
                $(this).removeClass('active')
                $('#' + $(this).data('target')).toggle()
            })
            $(this).addClass('active')
        }
    })

    if ($('.masonry').length) {
        $('.masonry').isotope({
            itemSelector: '.grid-item',
            percentPosition: true,
            masonry: {
                gutter: 10
            }
        })
    }

    // magnificPopup
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $('.magnific-image').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
    })

    // statistics
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $('.single-match .statistics').each(function() {

        var statistic = $(this)
        statistic.find('.item').each(function() {

            var item = $(this)
            var home = $(this).find('.home')
            var guest = $(this).find('.guest')
            var title = $(this).find('.title')

            home.find('div').each(function(index, el) {

                var current_home = home.find('div:nth-child(' + (index + 1) + ')')
                var current_home_value = current_home.text()

                var current_guest = guest.find('div:nth-child(' + (index + 1) + ')')
                var current_guest_value = current_guest.text()

                var total = parseInt(current_home_value) + parseInt(current_guest_value)

                if (current_home.text() == 0) {
                    current_home.addClass('zero')
                }

                if (current_guest.text() == 0) {
                    current_guest.addClass('zero')
                }

                if (current_home_value > current_guest_value) {
                    current_home.addClass('plus')
                }

                if (current_home_value < current_guest_value) {
                    current_guest.addClass('plus')
                }

                if (!current_home.hasClass('zero')) {
                    current_home.css({
                        'width': 'calc(' + current_home_value + '  * 100% / ' + total + ')'
                    })
                }

                if (!current_guest.hasClass('zero')) {
                    current_guest.css({
                        'width': 'calc(' + current_guest_value + '  * 100% / ' + total + ')'
                    })
                }

            })

        })

    })

    $('.share-wrapper').appendTo($('article > .inner-wrap > .post-content > .content-inner > .vc_row:nth-child(1) > .col > .wpb_column:nth-child(3)'))
    $('.last-news-wrapper').appendTo($('article > .inner-wrap > .post-content > .content-inner > .vc_row:nth-child(1) > .col > .wpb_column:nth-child(1)'))

    $.fn.isInViewport = function() {

        var elementTop = this.offset().top;
        var elementBottom = elementTop + this.outerHeight();

        var viewportTop = $(window).scrollTop();
        var viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    };


    $(window).on('resize scroll', function() {

        $('.hero.hero-score, .hero.game').each(function() {
            if ($(this).isInViewport()) {
                $('.logo-red').hide();
                $('.logo-black').show();
            } else {
                $('.logo-red').show();
                $('.logo-black').hide();
            }
        });

    });

    $(window).on('resize', function() {
        if ($(window).width() > 999) {
            $('.hero-home .hero').outerHeight($('.hero-home .hero-home__sidebar').height() + 122);
        } else {
            $('.hero-home .hero').css({
                'height': 'unset',
            });
        }
    });

    // News grid more
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $(document).on('click', '.news-grid-more', function(event) {
        event.preventDefault();

        var news_grid_button = $(this);
        var news_grid_id = news_grid_button.data('id');
        var news_grid_element = $('#news-grid-' + news_grid_id);

        var news_grid_columns = news_grid_element.data('columns');
        var news_grid_displayed = news_grid_element.data('displayed');
        var news_load_more = news_grid_element.data('load-more');
        var news_grid_step = news_grid_element.data('step');

        var linked_category = news_grid_element.data('linked-category');
        var linked_match = news_grid_element.data('linked-match');
        var linked_player = news_grid_element.data('linked-player');

        $.ajax({
            url: siteGlobals.ajaxUrl,
            type: "POST",
            cache: false,
            data: {
                'action': 'news_grid_more',
                'columns': news_grid_columns,
                'load_more': news_load_more,
                'maximum': news_grid_displayed + news_grid_step,
                'step': news_grid_step,
                'security': siteGlobals.ajaxNonce,

                'linked_category': linked_category,
                'linked_match': linked_match,
                'linked_player': linked_player,

            },
            beforeSend: function() {
                news_grid_button.find('i')
                    .removeClass('fa-arrow-right')
                    .addClass('fa-circle-notch spin')
            },
            success: function(response) {
                var news_grid_element_replacement = $(response)
                news_grid_element.replaceWith(news_grid_element_replacement)
                news_grid_element_replacement.fadeIn()
                news_grid_button.find('i')
                    .removeClass('fa-circle-notch spin')
                    .addClass('fa-arrow-right')
            },
        });
    });

    $(window).on('resize', function() {

        var height = 0;
        height += $('.hero-home__next-game').outerHeight();
        height += $('.hero-home__date-place').outerHeight();
        height += $('.hero-home__team-logos').outerHeight();
        height += $('.hero-home__kickoff').outerHeight();
        height += $('.hero-home__links').outerHeight();

        if ($(window).width() > 999) {

            $('.hero-home')
                .height(height + 122)
                .find('.hero-home__slider')
                .width($(window).width() - $('.hero-home__sidebar').width())
                .height(height + 122)
                .find('.flickity-viewport')
                .height(height + 122);

        } else {

            $('.hero-home')
                .height(400)
                .find('.hero-home__slider')
                .width($(window).width() - $('.hero-home__sidebar').width())
                .height(400)
                .find('.flickity-viewport')
                .height(400);

            $('.hero-home__slider')
                .css({
                    'width': '100%',
                });
        }
    });
    
    $(document).ready(() => {

        $('.post-area').css({
            'height': 'unset',
        })
    })

    // Trigger resize for salient
    // ■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■■
    $(document).ready(() => {
        window.dispatchEvent(new Event('resize'))
    })

})(jQuery)